<template>
  <!-- Interruptor, e não caixa de seleção: assim ele encolhe para ícone no xs como os outros botões
       do cabeçalho, em vez de ocupar uma linha inteira só para si. O olho cortado é o mesmo idioma
       que o design usa para "invisível". O estado se lê pelo preenchimento, que é o que sobra quando
       o rótulo some. `.stop`: num cabeçalho de seção, o clique não chega ao que está por baixo. -->
  <ontos-header-action :icon="modelValue ? 'mdi-eye' : 'mdi-eye-off'"
                       :label="$tt('show-closed-items')"
                       :variant="modelValue ? 'tonal' : 'text'"
                       :color="modelValue ? 'primary' : undefined"
                       @click.stop="$emit('update:modelValue', !modelValue)"/>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * O "Mostrar encerrados" — os itens em situação final, que as listas escondem por padrão. Um
 * componente porque são três lugares — a grade da coleção e, na ficha, a linha das abas de um
 * relacionamento ou a linha de baixo dela, no telefone —, e os três têm de ser o mesmo botão.
 */
@Component({name: 'ontos-show-closed-toggle', emits: ['update:modelValue']})
class ShowClosedToggle extends Vue {
  @Prop({type: Boolean, default: false}) readonly modelValue!: boolean
}

export default toNative(ShowClosedToggle)
</script>
